<template>
  <div class="cellContainer">
    <div class="editable-cell">
      <div v-if="editable" class="editable-cell-input-wrapper">
        <a-input :value="value" @change="handleChange" @pressEnter="check" /><a-icon
          type="check"
          class="editable-cell-icon-check"
          @click="check"
        />
      </div>
      <div v-else class="editable-cell-text-wrapper">
        {{ value || ' ' }}
        <!-- <a-icon type="edit" class="editable-cell-icon" @click="edit" /> -->
        <img class="editable-cell-icon" :src="require('@/assets/images/tdEditIcon.png')" alt=""  @click="edit" >
      </div>
    </div>
  </div>
</template>
     
<script>
    export default {
    name: 'editFwcellDialog',
    props: {
        text: String,
    },
    data() {
        return {
        value: this.text,
        editable: false,
        }
    },

    methods: {
        // 名称编辑方法
        handleChange(e) {
        const value = e.target.value
        this.value = value
        },
        check() {
        this.editable = false
        this.$emit('change', this.value)
        },
        edit() {
        this.editable = true
        },
    },
    }
</script>
     
<style lang="less" scoped>
    .cellContainer {
        height: 34px;
        line-height: 34px;
        .editable-cell {
            position: relative;
        }

        .editable-cell-input-wrapper,
        .editable-cell-text-wrapper {
            padding-right: 24px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            height: 34px;
            border-radius: 4px;
        }

        .editable-cell-text-wrapper {
            padding: 0;
        }

        .editable-cell-icon,
        .editable-cell-icon-check {
            position: absolute;
            right: 2px;
            width: 20px;
            cursor: pointer;
        }

        .editable-cell-icon {
            line-height: 18px;
            display: none;
        }

        .editable-cell-icon-check {
            line-height: 34px;
            color: rgba(255, 255, 255, 0.50);
        }

        .editable-cell:hover .editable-cell-icon {
            display: inline-block;
        }

        .editable-add-btn {
            margin-bottom: 8px;
        }
        /deep/ .ant-input {
            border: 0;
            border-radius: 0;
            background: transparent;
            color: rgba(255, 255, 255, 0.50) !important;
            font-size: 16px !important;
        }
    }
</style>
     